import Faq from '../components/Faq'
import BreedServices from '../components/BreedServices'
import NewsLetter from '../components/NewsLetter'
import ShopAreaCat from '../components/ourshop/ShopAreaCat';
import BreadCumbcat from '../components/catlists/BreadCumb';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';


function CatList() {
useEffect(() => {
  window.scrollTo({ top: 0, behavior: "smooth" });
}, []);


	return (

		<main>
						 <Helmet>
        <title>Chats - Animalia</title>
        <meta name="description" content="Découvrez notre sélection de nos produits pour chats chez Animalia." />
      </Helmet>

			<BreadCumbcat/>
			<ShopAreaCat />
			{/* <AdoptionShop/> */}
			<Faq afterElment="faq-area-two" />
			<BreedServices />
			<NewsLetter />
		</main>
	)
}

export default CatList;
